<template>
  <div class="col-md-12 p-0 mx-auto">
    <!-- پاپ آپ ایجاد API Key جدید -->
    <custom-popup
      hide-confirm
      :cons="{ title: 'ایجاد API Key جدید' }"
      v-model="createModal"
      max-width="600"
      transition="dialog-bottom-transition"
    >
      <v-card class="p-5">
        <div class="mb-4">
          <label>عنوان</label>
          <v-text-field
            v-model="newKeyTitle"
            type="text"
            class="form-control mt-2"
            placeholder="مثلا: api"
            @keyup.enter="generateApiKey"
            outlined
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
          />
        </div>
        <div class="d-flex justify-end">
          <v-btn
            :loading="creating"
            @click="generateApiKey"
            class="btn-get-code rounded-lg"
            ><v-icon>mdi-api</v-icon>
            تولید و ثبت
          </v-btn>
        </div>

        <div
          v-if="generatedData"
          class="mt-5 p-4 rounded-lg"
          style="background-color: #f5f5f5; border: 1px solid #e0e0e0"
        >
          <div class="text-success mb-3 font-weight-bold">
            <v-icon color="success">mdi-check-circle</v-icon>
            کلید با موفقیت ساخته شد. لطفا توکن زیر را کپی کنید (این توکن دیگر
            نمایش داده نخواهد شد).
          </div>
          <div class="mb-2">
            <strong>عنوان: </strong> {{ generatedData.title }}
          </div>
          <div>
            <strong>توکن (Token): </strong>
            <div
              class="mt-2 p-2 rounded d-flex justify-space-between align-center"
              style="
                background: #fff;
                border: 1px solid #ccc;
                word-break: break-all;
              "
            >
              <span>{{ generatedData.token }}</span>
              <v-btn icon small @click="copyToken(generatedData.token)">
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </custom-popup>

    <v-card :loading="loading" flat class="p-3 mx-2">
      <div class="mb-4 d-flex justify-space-between">
        <v-btn @click="openCreateModal" class="btn-get-code rounded-lg">
          <v-icon>mdi-plus</v-icon>
          ایجاد API Key جدید
        </v-btn>
        <v-btn @click="downloadFile" class="btn-download rounded-lg">
          <v-icon class="me-2">mdi-book</v-icon>
          دریافت مستندات برنامه نویس
        </v-btn>
      </div>

      <vue-table
        :headers="headers"
        :loading.sync="loading"
        :props.sync="tableProps"
        @change="onPagination"
        :data="datas"
      >
        <template v-slot:filters="{ props, perPage }">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.length"
                :items="perPage"
                :menu-props="{ offsetY: true }"
                class="rounded-lg"
                dense
                item-text="page"
                item-value="page"
                label="تعداد"
                outlined
              />
            </v-col>

            <v-col class="pa-2" cols="12" lg="3" md="4">
              <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                label="جست و جو"
                outlined
              />
            </v-col>
          </v-row>
        </template>

        <template v-slot:index="{ item }">
          {{ item.index + 1 }}
        </template>
        <template v-slot:token="{ item }">
          <div class="d-flex align-center justify-center" dir="ltr">
            <span>{{ truncateText(item.token) }}</span>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click="copyToken(item.token)"
                  class="ml-2"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </template>
              <span>کپی توکن</span>
            </v-tooltip>
          </div>
        </template>

        <template v-slot:updated_at="{ item }">
          {{ jalalian(item.updated_at) }}
        </template>

        <template v-slot:action="{ item }">
          <manage-button :data="item" :meta="metaButtons" />
        </template>
      </vue-table>
    </v-card>
  </div>
</template>

<script>
import manageButton from "@/view/pages/button.vue";

export default {
  name: "ApiKeyManager",
  components: { manageButton },
  data() {
    return {
      loading: false,
      creating: false,
      createModal: false,
      newKeyTitle: "api",
      generatedData: null, // متغیر جدید برای ذخیره اطلاعات کلید ساخته شده
      datas: {},
      tableProps: {
        search: "",
        length: 10,
        dir: "desc",
      },
      data: [],
      headers: [
        { value: "index", text: "ردیف", sortable: false, align: "center" },
        { value: "id", text: "شناسه", sortable: false, align: "center" },
        { value: "title", text: "عنوان", sortable: false, align: "center" },
        { value: "token", text: "توکن", sortable: false, align: "center" },
        {
          value: "updated_at",
          text: "آخرین به روزرسانی",
          sortable: false,
          align: "center",
        },
        { value: "action", text: "مدیریت", sortable: false, align: "center" },
      ],
      metaButtons: {
        buttons: [
          {
            name: "delete",
            label: "حذف",
            icon: "trash",
            class: "btn-delete border-2 rounded-pill",
            action: this.actions,
            status: "phoneBook_show",
          },
        ],
      },
    };
  },
  methods: {
    downloadFile() {
      const fileName = "doc_prog_api.pdf";
      const filePath = `/media/${fileName}`;
      const downloadLink = document.createElement("a");

    downloadLink.href = encodeURI(filePath); 
    downloadLink.download = fileName;

    document.body.appendChild(downloadLink);
    downloadLink.click();

    document.body.removeChild(downloadLink);    
  },

    truncateText(text) {
      if (!text) return "";
      if (text.length <= 12) return text;
      return text.substring(0, 12) + "...";
    },
    onPagination(e) {
      let props = {
        ...this.tableProps,
        ...e,
      };

      this.getData(props);
    },
    // گرفتن لیست API Key ها
    getData(query = this.tableProps) {
      this.loading = true;
      this.$api
        .get(`/apiKey`, {
          params: { ...query },
        })
        .then((response) => {
          const data = response.data.data || response.data;
          this.datas = { data: data, search: "", length: 10, dir: "desc" };
        })
        .catch(() => {
          this.$modal.error(
            "خطا",
            "در دریافت لیست API Key با خطا مواجه‌ شدیم.",
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    reloadTable(tableProps) {
      setTimeout(() => {
        this.getData(tableProps);
      }, 700);
    },

    openCreateModal() {
      this.newKeyTitle = "api";
      this.generatedData = null; // پاک کردن اطلاعات قبلی هنگام باز شدن مجدد
      this.createModal = true;
    },

    // تولید API Key جدید
    generateApiKey() {
      if (!this.newKeyTitle) {
        this.$toast.error("لطفا عنوان را وارد کنید.");
        return;
      }

      this.creating = true;
      this.generatedData = null; // پاک کردن اطلاعات در صورت تلاش مجدد

      this.$api
        .post(`/apiKey/gen`, {
          title: this.newKeyTitle,
        })
        .then((response) => {
          this.$toast.success("کلید جدید با موفقیت ایجاد شد.");

          // دریافت اطلاعات کلید ساخته شده از ریسپانس
          this.generatedData = response.data.data || response.data;

          this.reloadTable();
          // مودال دیگر بسته نمی‌شود تا کاربر بتواند توکن را کپی کند
        })
        .catch(() => {
          this.$modal.error("خطا", "در ایجاد API Key خطایی رخ داد.");
        })
        .finally(() => {
          this.creating = false;
        });
    },

    actions(data, type) {
      this[type + "Action"](data);
    },

    copyToken(t) {
      if (!t) return;
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(t)
          .then(() => {
            this.$toast.success("توکن کپی شد."); // افزودن پیام موفقیت کپی
          })
          .catch((err) => {
            console.error("Clipboard error:", err);
          });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = t;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        this.$toast.success("توکن کپی شد.");
      }
    },

    deleteAction(data) {
      this.$modal
        .yesNo("تایید حذف", "آیا از حذف این API Key اطمینان دارید؟", "neg", "")
        .then((value) => {
          if (value === true) {
            this.loading = true;
            this.$api
              .delete(`/apiKey/${data.id}`)
              .then(() => {
                this.$toast.success("با موفقیت حذف شد.");
                this.reloadTable();
              })
              .catch(() => {
                this.$modal.error("خطا", "در حذف اطلاعات خطایی رخ داد.");
                this.loading = false;
              });
          }
        });
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
